import { msg } from '@lingui/macro'

/**
 * Mappa label inglesi da structure.json → descriptor Lingui.
 * Usato per tradurre etichette nei grafici dashboard / polygon stats.
 */
export const STATS_CONFIG_LABEL_MESSAGES = Object.freeze({
  Unknown: msg`Unknown`,
  Fatal: msg`Fatal`,
  'Serious injury': msg`Serious injury`,
  'Slight injury': msg`Slight injury`,
  'No injury': msg`No injury`,
  'Not injuried': msg`Not injuried`,
  Death: msg`Death`,
  'Other or unknown': msg`Other or unknown`,
  'Dry/clear': msg`Dry/clear`,
  Rain: msg`Rain`,
  Snow: msg`Snow`,
  'Fog/mist/smoke': msg`Fog/mist/smoke`,
  'Sleet/hail': msg`Sleet/hail`,
  'Severe winds': msg`Severe winds`,
  Male: msg`Male`,
  Female: msg`Female`,
  Urban: msg`Urban`,
  Rural: msg`Rural`,
  'Mixed / rural village': msg`Mixed / rural village`,
  'Primary arterial': msg`Primary arterial`,
  'Secondary arterial': msg`Secondary arterial`,
  Collector: msg`Collector`,
  Local: msg`Local`,
  Other: msg`Other`,
  'Driver/rider': msg`Driver/rider`,
  Passenger: msg`Passenger`,
  Pedestrian: msg`Pedestrian`,
  'Not applicable': msg`Not applicable`,
  'Positive (alcohol level above national legal limit)': msg`Positive (alcohol level above national legal limit)`,
  'Negative (alcohol level below national legal limit)': msg`Negative (alcohol level below national legal limit)`,
  'Not applicable (person not tested, passenger or pedestrian)': msg`Not applicable (person not tested, passenger or pedestrian)`,
  'Seat belt worn': msg`Seat belt worn`,
  'Seat belt not worn': msg`Seat belt not worn`,
  'Seat belt not installed on vehicle': msg`Seat belt not installed on vehicle`,
  'Child safety seat properly installed and used': msg`Child safety seat properly installed and used`,
  'Child safety seat not properly installed/used (child on board)': msg`Child safety seat not properly installed/used (child on board)`,
  'Crash helmet worn': msg`Crash helmet worn`,
  'Crash helmet not worn': msg`Crash helmet not worn`,
  'Single-vehicle crash': msg`Single-vehicle crash`,
  'Collision with parked vehicle': msg`Collision with parked vehicle`,
  'Crash with pedestrian crossing the road': msg`Crash with pedestrian crossing the road`,
  'Crash with pedestrian walking or standing on the road side': msg`Crash with pedestrian walking or standing on the road side`,
  'Other pedestrian crash': msg`Other pedestrian crash`,
  'Crash with cyclist': msg`Crash with cyclist`,
  'Crashes between vehicles: head-on collision': msg`Crashes between vehicles: head-on collision`,
  'Crashes between vehicles: rear-end collision': msg`Crashes between vehicles: rear-end collision`,
  'Crashes between vehicles: side collision': msg`Crashes between vehicles: side collision`,
  'Crashes between vehicles: turning or crossing': msg`Crashes between vehicles: turning or crossing`,
  'Crashes between vehicles: overtaking': msg`Crashes between vehicles: overtaking`,
  'Crashes between vehicles: other': msg`Crashes between vehicles: other`,
})

/**
 * @param {string | number | undefined} label
 * @param {(descriptor: import('@lingui/macro').MessageDescriptor) => string} translate
 */
export function translateStatsConfigLabel(label, translate) {
  const key = String(label ?? '').trim()
  if (!key) return ''
  const descriptor = STATS_CONFIG_LABEL_MESSAGES[/** @type {keyof typeof STATS_CONFIG_LABEL_MESSAGES} */ (key)]
  return descriptor ? translate(descriptor) : key
}
